/**
 * Склоняемые формы слова: [для «one», для «few», для «many»].
 * Например: ['день', 'дня', 'дней'].
 */
export type TWordDeclensionTitles = [string, string, string];

/**
 * Возвращает правильную форму слова в зависимости от числа (плюральные правила ru).
 *
 * @param number — число, от которого зависит окончание
 * @param titles — массив форм слова [one, few, many]
 * @returns склонённая форма слова
 */
export const wordDeclension = (number: number, titles: TWordDeclensionTitles): string => {
  const pluralRule = new Intl.PluralRules('ru').select(number);

  switch (pluralRule) {
    case 'one':
      return titles[0];
    case 'few':
      return titles[1];
    default:
      return titles[2];
  }
};
